module.exports = __webpack_public_path__ + "img/bb_g1_t_antenna-02.b31bfd11.svg";